import React, { useState, useEffect } from "react";
import axios from "axios";

export default function ContactUs() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });
  const [status, setStatus] = useState("");
  const [company, setCompany] = useState(null);

  // Fetch company info from API
  useEffect(() => {
    const fetchCompanyInfo = async () => {
      try {
        const response = await axios.get(
          "https://cartbackend.wsdstech.com/api/company-info"
        );
        setCompany(response.data); // assuming API returns {address, email, contact_no}
      } catch (error) {
        console.error("Error fetching company info", error);
      }
    };
    fetchCompanyInfo();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("https://cartbackend.wsdstech.com/api/contact", form);
      setStatus("✅ Your message has been sent successfully!");
      setForm({ name: "", email: "", message: "" });
    } catch (error) {
      console.error("Error sending message", error);
      setStatus("❌ Something went wrong. Please try again later.");
    }
  };

  return (
    <div className="container my-5">
      {/* Page Title */}
      <div className="text-center mb-5">
        <h1 className="display-4 font-weight-bold">Contact Us</h1>
        <p className="lead text-muted">
          Have any questions? Feel free to reach out to us using the form below.
        </p>
      </div>

      {/* Status Message */}
      {status && (
        <div
          className={`alert ${
            status.includes("✅") ? "alert-success" : "alert-danger"
          }`}
        >
          {status}
        </div>
      )}

      <div className="row">
        {/* Contact Form */}
        <div className="col-md-6 mb-4">
          <div className="card shadow-sm border-0">
            <div className="card-body">
              <h3 className="h4 mb-4">Send Us a Message</h3>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    className="form-control"
                  />
                </div>

                <div className="form-group">
                  <label>Message</label>
                  <textarea
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="form-control"
                  ></textarea>
                </div>

                <button type="submit" className="btn btn-primary btn-block">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>

        {/* Contact Info + Map */}
        <div className="col-md-6">
          <div className="card shadow-sm border-0 mb-4">
            <div className="card-body">
              <h3 className="h4 mb-3">Our Contact Information</h3>
              {company ? (
                <>
                  <p>📍 <strong>Address:</strong> {company.address}</p>
                  <p>📧 <strong>Email:</strong> {company.email}</p>
                  <p>📞 <strong>Phone:</strong> {company.contact_no}</p>
                </>
              ) : (
                <p>Loading company info...</p>
              )}
            </div>
          </div>

          <div className="card shadow-sm border-0">
            <div className="card-body p-0">
              {company && company.address ? (
                <iframe
                  title="Google Map"
                  src={`https://www.google.com/maps?q=${encodeURIComponent(
                    company.address
                  )}&output=embed`}
                  width="100%"
                  height="250"
                  frameBorder="0"
                  style={{ border: 0 }}
                  allowFullScreen=""
                  aria-hidden="false"
                ></iframe>
              ) : (
                <p className="text-center py-3">Loading map...</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
